import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import SubNav from './sub-nav'
import MobileSearchBar from 'shared/mobile-search-bar'
import { compose } from 'redux'
import { getTopLevelTopicSlugFromPath } from '../lib'
import { helloBabySearchPath } from '../../lib/urls'
import { withContextualizedTracking, track } from 'lib/analytics'

class App extends React.Component {
  static contextTypes = {
    minimalView: PropTypes.bool,
  }

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    // listen for other parts of our site (mobile nav) to trigger route changes
    PubSub.subscribe(BLConstants.ROUTE_CHANGE, (path) => {
      this.props.router.push(path)
    })
  }

  render() {
    return (
      <div style={{ minHeight: 'calc(100vh)' }}>
        {!this.context.minimalView ? (
          <SubNav
            className="hidden-xs"
            searchTerm={this.props.location.query.search_term}
            topicSlug={getTopLevelTopicSlugFromPath(
              this.props.location.pathname,
              this.props.posts,
              this.props.state
            )}
            topics={this.props.topicNavigation.items}
          />
        ) : null}

        {!this.context.minimalView ? (
          <MobileSearchBar
            placeholder="Search guides"
            submitPath={helloBabySearchPath}
          />
        ) : null}

        {/* the top margin class is applied if we are not on a post (guide, article, sample registry) page */}
        {this.props.children}
      </div>
    )
  }
}

export default compose(
  withContextualizedTracking({ eventLocation: track.EventLocation.HOME_PAGE }),
  withRouter
)(App)
